const TGF_BASE_ADDRESS = "Rua Antero de Quental 656, Porto, Portugal";
const TGF_STRIPE_ENDPOINT = "https://stripe-backend-ten-chi.vercel.app/api/create-checkout-session";
const TGF_WHATSAPP_NUMBER = "351960041075";

const TGF_CHILD_SEAT_PRICE = 10;
const TGF_MIN_TRANSFER_PRICE_EUR = 45;

function tgfText(id) {
  const el = document.getElementById(id);
  return el ? String(el.value || "").trim() : "";
}

function tgfNumber(id) {
  const el = document.getElementById(id);
  return el ? Number(el.value || 0) : 0;
}

function tgfSetText(id, value) {
  const el = document.getElementById(id);
  if (el) el.innerText = value;
}

function roundPremium(value) {
  if (value >= 100) return Math.round(value / 10) * 10;
  return Math.round(value / 5) * 5;
}

function calculateChildSeatExtra() {
  const childrenCount = tgfNumber("childrenCount");
  const heightsRaw = tgfText("childrenHeights");

  if (!childrenCount || !heightsRaw) {
    return {
      childSeats: 0,
      boosters: 0,
      totalSeats: 0,
      seatsExtra: 0
    };
  }

  const heights = heightsRaw
    .split(",")
    .map(value => parseInt(value.trim(), 10))
    .filter(value => !isNaN(value));

  let childSeats = 0;
  let boosters = 0;

  heights.forEach(height => {
    if (height <= 125) {
      childSeats += 1;
    } else if (height >= 126 && height <= 150) {
      boosters += 1;
    }
  });

  const totalSeats = childSeats + boosters;
  const seatsExtra = totalSeats * TGF_CHILD_SEAT_PRICE;

  return {
    childSeats,
    boosters,
    totalSeats,
    seatsExtra
  };
}

function isTooGenericPlace(value) {
  const text = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

  const genericPatterns = [
    /^porto(\s*[·,-]\s*porto)?$/,
    /^braga(\s*[·,-]\s*braga)?$/,
    /^lisboa(\s*[·,-]\s*lisboa)?$/,
    /^lisbon(\s*[·,-]\s*lisbon)?$/,
    /^coimbra(\s*[·,-]\s*coimbra)?$/,
    /^guimarães(\s*[·,-]\s*guimarães)?$/,
    /^guimaraes(\s*[·,-]\s*guimaraes)?$/,
    /^aveiro(\s*[·,-]\s*aveiro)?$/,
    /^viana do castelo(\s*[·,-]\s*viana do castelo)?$/
  ];

  return genericPatterns.some(pattern => pattern.test(text));
}

function validateSpecificRoute(origin, destination) {
  if (isTooGenericPlace(origin) || isTooGenericPlace(destination)) {
    alert("Please select a more specific origin and destination, such as a hotel, airport, station, full address or recognised place. City names alone may not be enough to calculate the route.");
    return false;
  }

  return true;
}

function formatPlaceAddress(place, fallbackValue = "") {
  const name = String(place?.name || "").trim();
  const address = String(place?.formatted_address || "").trim();

  if (!name && !address) {
    return fallbackValue;
  }

  if (!name) {
    return address;
  }

  if (!address) {
    return name;
  }

  const cleanName = name.toLowerCase();
  const cleanAddress = address.toLowerCase();

  if (cleanAddress.includes(cleanName)) {
    return address;
  }

  return name + " · " + address;
}

function getRouteLeg(from, to) {
  return new Promise(function(resolve, reject) {
    if (!window.google || !google.maps || !google.maps.DirectionsService) {
      reject("Google Maps failed to load.");
      return;
    }

    const service = new google.maps.DirectionsService();

    service.route(
      {
        origin: from,
        destination: to,
        travelMode: google.maps.TravelMode.DRIVING,
        region: "PT"
      },
      function(result, status) {
        if (status !== "OK") {
          reject(status);
          return;
        }

        const leg = result.routes[0].legs[0];

        resolve({
          km: leg.distance.value / 1000,
          minutes: leg.duration.value / 60
        });
      }
    );
  });
}

window.calculateTransferEstimate = async function() {
  const origin = tgfText("origin");
  const destination = tgfText("destination");
  const travelDate = tgfText("travelDate");
  const travelTime = tgfText("travelTime");

  if (!travelDate) {
    alert("Please select the transfer date before calculating the price.");
    return;
  }

  if (!travelTime) {
    alert("Please select the transfer time before calculating the price.");
    return;
  }

  if (!origin || !destination) {
    alert("Please enter both origin and destination.");
    return;
  }

  if (!validateSpecificRoute(origin, destination)) {
    return;
  }

  try {
    const passengers = tgfNumber("passengers");
    const serviceType = tgfText("serviceType");
    const waitingTime = tgfNumber("waitingTime");
    const checkedBags = tgfNumber("checkedBags");
    const trolleys = tgfNumber("trolleys");
    const largeBackpacks = tgfNumber("largeBackpacks");
    const golfBags = tgfNumber("golfBags");

    const seatsData = calculateChildSeatExtra();

    const route = await getRouteLeg(origin, destination);
    const baseToOrigin = await getRouteLeg(TGF_BASE_ADDRESS, origin);
    const destinationToBase = await getRouteLeg(destination, TGF_BASE_ADDRESS);

    const luggageVolume =
      checkedBags * 1.5 +
      trolleys +
      largeBackpacks +
      golfBags * 2;

    let vehicle = "Standard Vehicle";
    let multiplier = 1;

    if (passengers > 5 || luggageVolume > 5) {
      vehicle = "Van";
      multiplier = 1.25;
    }

    if (passengers > 8) {
      tgfSetText("resultDistance", "On request");
      tgfSetText("resultDuration", "On request");
      tgfSetText("resultVehicle", "Manual validation");
      tgfSetText("resultExtras", "On request");
      tgfSetText("resultPrice", "On request");
      tgfSetText("resultNote", "Groups above eight guests require manual validation.");

      const result = document.getElementById("transferResult");
      if (result) result.style.display = "block";

      return;
    }

    const operationalKm =
      baseToOrigin.km +
      route.km +
      destinationToBase.km;

    let kmRate = route.km > 120 ? 0.60 : 0.55;
    let basePrice = operationalKm * kmRate * multiplier;

    let minimumPrice = 0;

    if (route.km <= 35) {
      minimumPrice = vehicle === "Van" ? 90 : 45;
    } else if (route.km > 35 && route.km <= 60) {
      minimumPrice = vehicle === "Van" ? 120 : 80;
    } else if (route.km > 60 && route.km <= 120) {
      minimumPrice = vehicle === "Van" ? 150 : 120;
    }

    basePrice = Math.max(basePrice, minimumPrice);
    basePrice = roundPremium(basePrice);

    const golfExtra = golfBags > 0 ? Math.min(golfBags * 10, 30) : 0;
    const seatsExtra = seatsData.seatsExtra;

    let operationalExtras = 0;

    if (serviceType === "roundtrip") {
      basePrice = basePrice * 2;
    }

    if (waitingTime > 60) {
      operationalExtras += ((waitingTime - 60) / 60) * 25;
    }

    const price = Math.max(
      basePrice + golfExtra + seatsExtra + operationalExtras,
      TGF_MIN_TRANSFER_PRICE_EUR
    );

    const extrasText = [];

    if (serviceType === "roundtrip") {
      extrasText.push("Round trip included");
    }

    if (waitingTime > 60) {
      const waitingExtra = ((waitingTime - 60) / 60) * 25;

      extrasText.push(
        "Additional waiting time: " +
        waitingExtra.toFixed(0) +
        " €"
      );
    }

    if (golfExtra > 0) {
      extrasText.push("Bulky equipment: " + golfExtra + " €");
    }

    if (seatsExtra > 0) {
      extrasText.push(
        "Child seats / boosters: " +
        seatsData.totalSeats +
        " x " +
        TGF_CHILD_SEAT_PRICE +
        " € = " +
        seatsExtra +
        " €"
      );
    }

    let displayKm = route.km;
    let displayMinutes = route.minutes;

    if (serviceType === "roundtrip") {
      displayKm = route.km * 2;
      displayMinutes = route.minutes * 2;
    }

    if (waitingTime > 0) {
      displayMinutes += waitingTime;
    }

    tgfSetText("resultDistance", displayKm.toFixed(0) + " km");
    tgfSetText("resultDuration", displayMinutes.toFixed(0) + " min");
    tgfSetText("resultVehicle", vehicle);
    tgfSetText("resultExtras", extrasText.length ? extrasText.join(" | ") : "0 €");
    tgfSetText("resultPrice", price + " €");
    tgfSetText("resultNote", "Estimated amount subject to final operational confirmation.");

    const result = document.getElementById("transferResult");
    if (result) result.style.display = "block";

    const button = document.querySelector(".tf-payment-button");
    if (button) {
      button.disabled = false;
      button.innerText = "Reserve and Pay";
    }

  } catch (error) {
    console.error("Transfer calculation error:", error);
    alert("Please select a specific address, hotel, airport, station or recognised place for both origin and destination. City names alone may not be enough to calculate the route.");
  }
};

window.resetTransferForm = function() {
  location.reload();
};

window.openWhatsAppPreLead = function() {
  const origin = tgfText("origin");
  const destination = tgfText("destination");
  const serviceType = tgfText("serviceType");
  const date = tgfText("travelDate");
  const time = tgfText("travelTime");
  const passengers = tgfText("passengers");
  const customerPhone = tgfText("customerPhone");
  const customerEmail = tgfText("customerEmail");
  const customerNotes = tgfText("customerNotes");

  const childrenCount = tgfNumber("childrenCount");
  const childrenAges = tgfText("childrenAges") || "Not specified";
  const childrenHeights = tgfText("childrenHeights") || "Not specified";
  const seatsData = calculateChildSeatExtra();

  const checkedBags = tgfNumber("checkedBags");
  const trolleys = tgfNumber("trolleys");
  const largeBackpacks = tgfNumber("largeBackpacks");
  const golfBags = tgfNumber("golfBags");

  const vehicle = document.getElementById("resultVehicle")?.innerText || "Not yet calculated";
  const price = document.getElementById("resultPrice")?.innerText || "Not yet calculated";

  const message =
    "3GREENFORCE • Private Transfer Request\n\n" +

    "JOURNEY DETAILS\n\n" +

    "Origin: " + origin + "\n" +
    "Destination: " + destination + "\n" +
    "Service Type: " + serviceType + "\n\n" +

    "SCHEDULE\n\n" +

    "Date: " + (date || "Not specified") + "\n" +
    "Pick-up Time: " + (time || "Not specified") + "\n" +
    "Guests: " + passengers + "\n\n" +

    "CHILDREN\n\n" +

    "Children up to 12 years old: " + childrenCount + "\n" +
    "Ages: " + childrenAges + "\n" +
    "Heights: " + childrenHeights + "\n" +
    "Child Seats: " + seatsData.childSeats + "\n" +
    "Booster Seats: " + seatsData.boosters + "\n" +
    "Child Seat Supplement: " + seatsData.seatsExtra + " €\n\n" +

    "LUGGAGE\n\n" +

    "Checked Bags: " + checkedBags + "\n" +
    "Cabin Trolleys: " + trolleys + "\n" +
    "Large Backpacks: " + largeBackpacks + "\n" +
    "Golf Bags / Bulky Equipment: " + golfBags + "\n\n" +

    "OPERATIONAL DETAILS\n\n" +

    "Recommended Vehicle: " + vehicle + "\n" +
    "Estimated Amount: " + price + "\n\n" +

    "GUEST DETAILS\n\n" +

    "Phone / WhatsApp: " + customerPhone + "\n" +
    "Email: " + customerEmail + "\n" +
    "Notes: " + (customerNotes || "None") + "\n\n" +

    "Please confirm availability and any final operational details.";

  window.open(
    "https://wa.me/" + TGF_WHATSAPP_NUMBER + "?text=" + encodeURIComponent(message),
    "_blank",
    "noopener,noreferrer"
  );
};

function initTransferAutocomplete() {
  if (!window.google || !google.maps || !google.maps.places) {
    console.warn("Google Places ainda não carregou.");
    return;
  }

  const options = {
    componentRestrictions: { country: ["pt", "es"] },
    fields: ["formatted_address", "geometry", "name"]
  };

  const originInput = document.getElementById("origin");
  const destinationInput = document.getElementById("destination");

  if (originInput && !originInput.dataset.autocompleteReady) {
    const originAutocomplete = new google.maps.places.Autocomplete(originInput, options);

    originAutocomplete.addListener("place_changed", function() {
      const place = originAutocomplete.getPlace();

      if (place) {
        originInput.value = formatPlaceAddress(place, originInput.value);
      }
    });

    originInput.dataset.autocompleteReady = "true";
  }

  if (destinationInput && !destinationInput.dataset.autocompleteReady) {
    const destinationAutocomplete = new google.maps.places.Autocomplete(destinationInput, options);

    destinationAutocomplete.addListener("place_changed", function() {
      const place = destinationAutocomplete.getPlace();

      if (place) {
        destinationInput.value = formatPlaceAddress(place, destinationInput.value);
      }
    });

    destinationInput.dataset.autocompleteReady = "true";
  }
}

window.goToPaymentLink = async function() {
  const priceEl = document.getElementById("resultPrice");
  const button = document.querySelector(".tf-payment-button");

  const date = tgfText("travelDate");
  const time = tgfText("travelTime");

  if (!date) {
    alert("Please select the transfer date before proceeding to payment.");
    return;
  }

  if (!time) {
    alert("Please select the transfer time before proceeding to payment.");
    return;
  }

  const selectedDateTime = new Date(date + "T" + time);
  const now = new Date();

  const diffMs = selectedDateTime.getTime() - now.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffHours < 12) {
    alert("Bookings with less than 12 hours notice require operational validation by the 3GREENFORCE team. Please contact us on WhatsApp for immediate confirmation.");
    openWhatsAppPreLead();
    return;
  }

  const selectedHour = Number(time.split(":")[0]);

  if (selectedHour < 6 || selectedHour >= 22) {
    alert("Bookings between 22:00 and 06:00 require operational validation by the 3GREENFORCE team. Please contact us on WhatsApp for immediate confirmation.");
    openWhatsAppPreLead();
    return;
  }

  const acceptTerms = document.getElementById("acceptTerms");

  if (!acceptTerms || !acceptTerms.checked) {
    alert("To proceed to payment, please confirm that you have read and accepted the operational conditions and cancellation policy.");
    return;
  }

  if (
    !priceEl ||
    priceEl.innerText.includes("On request") ||
    priceEl.innerText.includes("Sob consulta") ||
    priceEl.innerText.trim() === "-" ||
    priceEl.innerText.trim() === ""
  ) {
    alert("Please calculate the journey price first.");
    return;
  }

  const amountText = priceEl.innerText
    .replace("€", "")
    .replace(",", ".")
    .trim();

  const amountEUR = parseFloat(amountText);

  if (!amountEUR || amountEUR <= 0) {
    alert("Invalid amount.");
    return;
  }

  const protectedAmountEUR = Math.max(amountEUR, TGF_MIN_TRANSFER_PRICE_EUR);
  const amount = Math.round(protectedAmountEUR * 100);

  const origin = tgfText("origin");
  const destination = tgfText("destination");
  const passengers = tgfText("passengers");
  const vehicle = document.getElementById("resultVehicle")?.innerText || "";
  const customerPhone = tgfText("customerPhone");
  const customerEmail = tgfText("customerEmail");

  if (!customerEmail || !customerEmail.includes("@")) {
    alert("Please enter a valid email address.");
    return;
  }

  if (!customerPhone || customerPhone.length < 9) {
    alert("Please enter a valid phone number.");
    return;
  }

  try {
    if (button) {
      button.disabled = true;
      button.innerText = "Processing Payment...";
    }

    const response = await fetch(TGF_STRIPE_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        amount,
        name: "Private Transfer 3GREENFORCE",
        origin,
        destination,
        passengers,
        date,
        time,
        vehicle,
        customerPhone,
        customerWhatsApp: customerPhone,
        customerEmail
      })
    });

    const data = await response.json();

    if (data.url) {
      window.location.href = data.url;
    } else {
      alert(data.error || "Unable to initiate Stripe payment.");

      if (button) {
        button.disabled = false;
        button.innerText = "Reserve and Pay";
      }
    }

  } catch (error) {
    console.error("Stripe error:", error);
    alert("Unable to communicate with Stripe. Please try again.");

    if (button) {
      button.disabled = false;
      button.innerText = "Reserve and Pay";
    }
  }
};

document.addEventListener("DOMContentLoaded", function() {
  const originInput = document.getElementById("origin");
  const destinationInput = document.getElementById("destination");

  if (originInput) {
    originInput.removeAttribute("readonly");
    originInput.removeAttribute("disabled");
    originInput.value = "";
    originInput.placeholder = "Hotel, airport, station or full address";
  }

  if (destinationInput) {
    destinationInput.removeAttribute("readonly");
    destinationInput.removeAttribute("disabled");
    destinationInput.value = "";
    destinationInput.placeholder = "Hotel, airport, station or full address";
  }

  setTimeout(initTransferAutocomplete, 800);
});

/* === 3GFIX: unlock children ages and heights when children are selected === */
(function() {
  function findFieldByLabelText(text) {
    const labels = Array.from(document.querySelectorAll("label"));
    const label = labels.find(l =>
      l.textContent.trim().toLowerCase().includes(text.toLowerCase())
    );

    if (!label) return null;

    if (label.htmlFor) {
      return document.getElementById(label.htmlFor);
    }

    return label.parentElement?.querySelector("input, select, textarea");
  }

  function updateChildrenFields3G() {
    const childrenField =
      document.getElementById("childrenCount") ||
      findFieldByLabelText("Número de crianças") ||
      findFieldByLabelText("Number of children") ||
      document.querySelector('[name*="crianca"], [name*="children"], [id*="children"]');

    const agesField =
      document.getElementById("childrenAges") ||
      findFieldByLabelText("Idades") ||
      findFieldByLabelText("Ages") ||
      document.querySelector('[name*="idade"], [name*="ages"], [id*="ages"]');

    const heightsField =
      document.getElementById("childrenHeights") ||
      findFieldByLabelText("Alturas") ||
      findFieldByLabelText("Heights") ||
      document.querySelector('[name*="altura"], [name*="heights"], [id*="heights"]');

    if (!childrenField || !agesField || !heightsField) {
      console.warn("3GREENFORCE: children fields not fully found.");
      return;
    }

    const childrenCount = parseInt(childrenField.value || "0", 10);

    [agesField, heightsField].forEach(field => {
      if (childrenCount > 0) {
        field.disabled = false;
        field.readOnly = false;
        field.removeAttribute("disabled");
        field.removeAttribute("readonly");
        field.style.pointerEvents = "auto";
        field.style.opacity = "1";
        field.style.backgroundColor = "#fff";
        field.style.cursor = "text";
      } else {
        field.value = "";
        field.disabled = true;
        field.readOnly = true;
        field.setAttribute("disabled", "disabled");
        field.setAttribute("readonly", "readonly");
        field.style.pointerEvents = "none";
        field.style.opacity = "0.55";
      }
    });
  }

  document.addEventListener("change", updateChildrenFields3G);
  document.addEventListener("input", updateChildrenFields3G);
  document.addEventListener("DOMContentLoaded", updateChildrenFields3G);

  setTimeout(updateChildrenFields3G, 500);
})();